<template>
<v-layout>
  
  
  <v-col offset-md="1" md="10">
    
    <v-tabs
      background-color="grey darken-4"
      color="red"
      class="elevation-2"
      dark
      grow
      :icons-and-text="icons"
      >
      
      <v-tab>
        Products classification
        <v-icon>fa-tasks</v-icon>
      </v-tab>
      
      <!-- ---------------------------------------------------------------------------------------------------- -->
      <v-tab-item>
	<v-card>
	  <v-card-title>
	    Types
	  </v-card-title>
	  
	  <v-card-text>
	    <v-row v-for="type in types" :key="type.name">
	      <v-col md="10">
		<v-text-field
		  v-model="type.name"
		  label="Name"
		  color="red"
		  ></v-text-field>
	      </v-col>
	      <v-col md="2">
		<v-btn text small color="error" @click="remType(type)">Delete</v-btn>
	      </v-col>
	    </v-row>
	    
	    <v-row>     
	      <v-col md="2">
		<v-container>
		  <v-btn text small color="success" @click="addType()">Add</v-btn>
		</v-container>
	      </v-col>
	      
	      <v-col md="2" offset-md="8">
		<v-btn class="ma-2" tile outlined color="success" @click="saveTypes()">
		  <v-icon left>fa-save</v-icon> Save
		</v-btn>
	      </v-col>
	    </v-row>
	    
	  </v-card-text>
	</v-card>
	
	<v-card>
	  <v-card-title>
	    Products
	    <v-spacer></v-spacer>
	    <v-text-field
              v-model="search"
              append-icon="fa-search"
	      color="red"
              label="Search"
              single-line
              hide-details
	      ></v-text-field>
	  </v-card-title>
	  
	  <v-data-table
	    :headers="headers"
	    :items="products"
	    :search="search"
	    disable-pagination
	    hide-default-footer
	    >
	    <template v-slot:item.type="{ item }">
	      <v-overflow-btn
		v-model="item.type.name"
		:items="getTypes()"
		label="Product type"
		></v-overflow-btn>
	    </template>
	  </v-data-table>
	  
	  <v-row>
	    <v-col md="10" offset-md="2">
	      <v-btn outlined large color="success" @click="saveProducts()">
		<v-icon left>fa-save</v-icon> Save
	      </v-btn>
	    </v-col>
	  </v-row>
	   
	</v-card>
      </v-tab-item>
    </v-tabs>
    
  </v-col>
</v-layout>
</template>

<script>
import { config } from '../config';

export default {
    components: {
	
    },
    
    data: () => ({
	booltrue: true,
	search: '',
	icons: true,
	headers: [
            { text: 'Name', value: 'name' },
            { text: 'Expected Files', value: 'expected_files' },
            { text: 'Type', value: 'type' },
	],
	products: [],
	types: [],
    }),
    
    created() {
	this.loadData();
	this.loadTypes();
    },
    
    watch: {
	
    },
    
    computed: {
    },
    
    methods: {
        loadData() {
            const url = `${config.baseUrl}products`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
                this.products = res.data;
		this.errorState = false;
		this.loading = false;
		
            }).catch((err) => {
                console.log(err);
		this.errorState = true;
            });
        },

	loadTypes() {
            const url = `${config.baseUrl}products/types`;
	    
            this.$http.get(url, { auth: this.$store.getters.auth }).then((res) => {
		
                res.data.report.forEach(type => {
		    this.types.push({name: type});
		});
		
		this.errorState = false;
		this.loading = false;
		
            }).catch((err) => {
                console.log(err);
		this.errorState = true;
            });
	},

	getTypes() {
	    let _types = [];

	    this.types.forEach(t => {
		_types.push(t.name);
	    });
	    
	    return _types;
	},
	
	addType() {
	    this.types.push({name: 'new type'});
	},
	
	remType(type) {
	    const idx = this.types.indexOf({name: type});
	    if (idx !== -1) this.types.splice(idx, 1);
	},

	saveTypes() {
	    let _types = [];

	    this.types.forEach(t => {
		_types.push(t.name);
	    });
	    
            const url = `${config.baseUrl}products/types`;
	    
	    this.$http.post(url, { types: _types }, { auth: this.$store.getters.auth }).then(res => {
	    	this.loadTypes();
	    	this.loadData();
	    }).catch(err => {
	    	console.log(err);
	    });
	},

	saveProducts() {
	    console.log(this.products);
	},
    },
};
</script>

<style lang="scss" scoped>

</style>
